import { render } from "./ModelImage.vue?vue&type=template&id=ee37c8e0"
import script from "./ModelImage.vue?vue&type=script&lang=js"
export * from "./ModelImage.vue?vue&type=script&lang=js"
script.render = render

export default script